type ViewportSubtract = {
  peerId: string | null;
  threadId: string | null;
  count: number;
};

let subtract: ViewportSubtract = { peerId: null, threadId: null, count: 0 };
const listeners = new Set<() => void>();

function emit() {
  for (const cb of listeners) cb();
}

export function setMessengerSidebarUnreadViewportSubtract(next: ViewportSubtract): void {
  if (
    subtract.peerId === next.peerId &&
    subtract.threadId === next.threadId &&
    subtract.count === next.count
  ) {
    return;
  }
  subtract = next;
  emit();
}

export function getMessengerSidebarUnreadViewportSubtract(): ViewportSubtract {
  return subtract;
}

export function subscribeMessengerSidebarUnreadViewportSubtract(onChange: () => void): () => void {
  listeners.add(onChange);
  return () => listeners.delete(onChange);
}
